// extracted by mini-css-extract-plugin
export var background = "ComparisonTable-module--background--f934d";
export var comparisontable = "ComparisonTable-module--comparisontable--cf810";
export var contained = "ComparisonTable-module--contained--ec61d";
export var fullComparison = "ComparisonTable-module--fullComparison--270fb";
export var heading = "ComparisonTable-module--heading--44d15";
export var right = "ComparisonTable-module--right--47f0d";
export var singleOptionComparison = "ComparisonTable-module--singleOptionComparison--b7305";
export var table = "ComparisonTable-module--table--4bb87";
export var tableContainer = "ComparisonTable-module--tableContainer--2a49f";
export var text = "ComparisonTable-module--text--7678b";